import { formatAnswerDateUTC } from '../../util/formatDate'
import { DisconnectOutlined } from '@ant-design/icons'

type MakeLabelProps = {
  createdAt: string
  deviceTime: string | null
  isOffline: boolean
  index?: number
  isPrimary?: boolean
}

export const AnswerSubmissionDetails = ({
  createdAt,
  deviceTime,
  isOffline,
  index = 0,
  isPrimary = false,
}: MakeLabelProps) => {
  const deviceTimeValue = deviceTime ? deviceTime : null

  const label: string = isOffline ? 'Sync Time: ' : index === 0 ? 'Submitted: ' : 'Answer: '
  return (
    <>
      <span
        className={isPrimary ? 'opacity-75 p-mini' : 'alpha-80'}
        style={{ display: 'block', marginBottom: !deviceTimeValue && !isOffline ? '3px' : 'none' }}
      >
        {label + formatAnswerDateUTC(createdAt)}
      </span>

      {deviceTimeValue && (
        <span className="p-mini opacity-50" style={{ display: 'block', marginBottom: !isOffline ? '3px' : 'none' }}>
          Device time: {deviceTimeValue}
        </span>
      )}

      {isOffline && index !== 0 && (
        <span className="p-mini opacity-50" style={{ display: 'block', marginBottom: '3px' }}>
          Offline <DisconnectOutlined />
        </span>
      )}
    </>
  )
}
